import { PathBase } from "@constellation-academy/epic-ui";

export class OfferFilesPath extends PathBase {
	static readonly pathKey = "offerFiles";
	static readonly pathName = "offer-files";
}
